import { render } from "./Transportation.vue?vue&type=template&id=251c2c82&scoped=true"
import script from "./Transportation.vue?vue&type=script&lang=js"
export * from "./Transportation.vue?vue&type=script&lang=js"

import "./Transportation.vue?vue&type=style&index=0&id=251c2c82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-251c2c82"

export default script